export default __webpack_public_path__ + "images/icon_attribution.0e3a36024e4c48929c98f62da3b365fa.svg";